export default "__VITE_ASSET__DIzV7ocT__"